import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function LoginPage() {
  const { user, isAdmin, loading, signIn } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && user && isAdmin) nav("/", { replace: true });
  }, [loading, user, isAdmin, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="card max-w-md w-full text-center">
        <img src="/logo.png" alt="Tomitra" className="w-16 h-16 rounded-2xl mx-auto mb-4 object-cover" />
        <h1 className="text-2xl font-semibold mb-1">Tomitra Admin</h1>
        <p className="text-sm text-slate-400 mb-6">
          Central dashboard for system health, costs, and operations.
        </p>
        <button
          onClick={() => signIn()}
          className="w-full bg-white text-slate-900 font-medium py-2.5 rounded-lg hover:bg-slate-100 transition"
        >
          Sign in with Google
        </button>
        <p className="text-xs text-slate-600 mt-6">
          Access is restricted to emails on the Tomitra admin allowlist.
        </p>
      </div>
    </div>
  );
}
